export const gridNewsStyle = {
    background: "linear-gradient(to right, #000000, #1A1A1E)",
    padding: "20px",
    borderRadius: "10px",
    borderImageSlice: 1,
};